import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-error-message',
    templateUrl: './error-message.component.html',
    styleUrls: ['./error-message.component.scss'],
    standalone: false
})
export class ErrorMessageComponent implements OnInit {
  constructor(protected dialogRef: DynamicDialogRef) {}

  ngOnInit(): void {}
  ok() {
    this.dialogRef.close();
  }
  close() {
    this.dialogRef.close(false);
  }
}
